module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//snow_4_1.png?v=2eb76a85";